




















































import { defineComponent } from 'vue';
import Icon from '../../../shared/components/Icon.vue';
import SortDropdown from '../../../shared/components/SortDropdown.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import { useSearchFilter } from '../../composables/global_search/useSearchFilter';
import { useSearchExecution } from '../../composables/global_search/useSearchExecution';
export default defineComponent({
  name: 'GlobalSearchSubFilters',
  components: { Icon, SortDropdown },
  setup() {
    const {
      role,
      groupType,
      mediaSort,
      profileOptions,
      groupOptions,
      sortOptions,
      selectedRoleLabel,
      selectedGroupTypeLabel,
      canFilterProfile,
      canFilterGroupType,
      canSortMedia,
    } = useSearchFilter();
    const { isLoading, totalCount, initializeSearch } = useSearchExecution();

    const handleSubFilterSelect = () => {
      initializeSearch();
    };

    const handleSortSelect = (value: 'asc' | 'desc') => {
      mediaSort.value = value;
      initializeSearch();
    };

    return {
      role,
      groupType,
      mediaSort,
      selectedRoleLabel,
      selectedGroupTypeLabel,
      canFilterProfile,
      canFilterGroupType,
      canSortMedia,
      profileOptions,
      groupOptions,
      sortOptions,
      isLoading,
      totalCount,
      handleSubFilterSelect,
      handleSortSelect,
      iconClassEnum,
    };
  },
});
